import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd1a5ff2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column mt-10"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "d-flex align-items-center flex-row mb-5" }
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-1" }, "Currency", -1))
const _hoisted_6 = { class: "mx-5 mt-7 mb-sm-0" }
const _hoisted_7 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexSwitchDefault"
}, "Enable night rates", -1))
const _hoisted_9 = {
  key: 0,
  class: "d-flex align-content-between flex-column"
}
const _hoisted_10 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Night hours ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle ms-1" }, null, -1))
const _hoisted_13 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_14 = ["id"]
const _hoisted_15 = ["id"]
const _hoisted_16 = { class: "table-responsive" }
const _hoisted_17 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2" }
const _hoisted_18 = { class: "fw-bolder text-muted" }
const _hoisted_19 = { class: "text-center" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px" }, " Skill ", -1))
const _hoisted_21 = { class: "min-w-100px" }
const _hoisted_22 = { class: "d-flex flex-column" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Standart", -1))
const _hoisted_24 = { class: "min-w-100px" }
const _hoisted_25 = { class: "d-flex flex-column" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Weekend", -1))
const _hoisted_27 = {
  key: 0,
  class: "min-w-120px"
}
const _hoisted_28 = { class: "d-flex flex-column" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Night Bonus", -1))
const _hoisted_30 = { class: "text-end" }
const _hoisted_31 = { class: "d-flex justify-content-end" }
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = ["value", "placeholder", "onChange"]
const _hoisted_34 = ["value", "placeholder", "onChange"]
const _hoisted_35 = { key: 0 }
const _hoisted_36 = ["placeholder", "value", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CurrenciesDropdown = _resolveComponent("CurrenciesDropdown")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_ctx.hasData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.job.book_from_branches.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("h3", null, _toDisplayString(_ctx.branch.name), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_CurrenciesDropdown, {
              modelValue: _ctx.companyRate.currency_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyRate.currency_id) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_switch, {
                modelValue: _ctx.companyRate.has_night_hours,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.companyRate.has_night_hours) = $event)),
                "active-value": 1,
                "inactive-value": 0
              }, null, 8, ["modelValue"]),
              _hoisted_8
            ])
          ]),
          (_ctx.companyRate.has_night_hours === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_el_tooltip, {
                    class: "item",
                    effect: "dark",
                    content: "Define when the 'NIGHT BONUS' starts and finishes (e.g. 19:00 - 07:00)",
                    placement: "top-start"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    id: `night_hours_1_${_ctx.branch.id}`,
                    class: "form-control me-4 w-100px h-40px",
                    inputmode: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.companyRate.night_start) = $event))
                  }, null, 8, _hoisted_14), [
                    [_vModelText, _ctx.companyRate.night_start]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    id: `night_hours_1_${_ctx.branch.id}`,
                    class: "form-control me-2 w-100px h-40px",
                    inputmode: "text",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.companyRate.night_end) = $event))
                  }, null, 8, _hoisted_15), [
                    [_vModelText, _ctx.companyRate.night_end]
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("table", _hoisted_17, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_18, [
                _createElementVNode("th", _hoisted_19, [
                  _createVNode(_component_el_checkbox, {
                    onChange: _cache[4] || (_cache[4] = event => _ctx.handleSelectAllRows(event))
                  })
                ]),
                _hoisted_20,
                _createElementVNode("th", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _hoisted_23,
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.bulkEdit.base_rate) = $event)),
                      class: "form-control w-100px h-30px"
                    }, null, 512), [
                      [_vModelText, _ctx.bulkEdit.base_rate]
                    ])
                  ])
                ]),
                _createElementVNode("th", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _withDirectives(_createElementVNode("input", {
                      type: "number",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.bulkEdit.weekend_bonus) = $event)),
                      class: "form-control w-100px h-30px"
                    }, null, 512), [
                      [_vModelText, _ctx.bulkEdit.weekend_bonus]
                    ])
                  ])
                ]),
                (_ctx.companyRate.has_night_hours === 1)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _hoisted_29,
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.bulkEdit.night_bonus) = $event)),
                          class: "form-control w-100px h-30px"
                        }, null, 512), [
                          [_vModelText, _ctx.bulkEdit.night_bonus]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("th", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("button", {
                      style: {"height":"28px"},
                      class: "d-flex align-items-center btn btn-sm btn-primary",
                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.applyBulkEdit && _ctx.applyBulkEdit(...args)))
                    }, " Apply ")
                  ])
                ])
              ])
            ]),
            (_openBlock(), _createElementBlock("tbody", { key: _ctx.tableKey }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientRates.skills, (skill, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_32, [
                    _createVNode(_component_el_checkbox, {
                      onChange: ($event: any) => (_ctx.handleBulkEditList(skill.id)),
                      checked: _ctx.bulkEditList.includes(skill.id)
                    }, null, 8, ["onChange", "checked"])
                  ]),
                  _createElementVNode("td", null, _toDisplayString(skill.name), 1),
                  _createElementVNode("td", null, [
                    _createElementVNode("input", {
                      type: "number",
                      min: "0",
                      value: _ctx.model[skill.id].standard_price,
                      class: "form-control w-100px h-30px",
                      placeholder: _ctx.model[skill.id].placeholder_standard ? _ctx.model[skill.id].placeholder_standard : '',
                      onChange: 
                event => (_ctx.model[skill.id].standard_price = event.target.value)
              
                    }, null, 40, _hoisted_33)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("input", {
                      type: "number",
                      min: "0",
                      value: _ctx.model[skill.id].weekend_price,
                      placeholder: _ctx.model[skill.id].placeholder_weekend ? _ctx.model[skill.id].placeholder_weekend : '',
                      class: "form-control w-100px h-30px",
                      onChange: 
                event => (_ctx.model[skill.id].weekend_price = event.target.value)
              
                    }, null, 40, _hoisted_34)
                  ]),
                  (_ctx.companyRate.has_night_hours === 1)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_35, [
                        _createElementVNode("div", null, [
                          _createElementVNode("input", {
                            type: "number",
                            min: "0",
                            placeholder: _ctx.model[skill.id].placeholder_night ? _ctx.model[skill.id].placeholder_night : '',
                            value: _ctx.model[skill.id].night_price,
                            class: "form-control w-100px h-30px",
                            onChange: 
                  event => (_ctx.model[skill.id].night_price = event.target.value)
                
                          }, null, 40, _hoisted_36)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}